// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Firerang",
  id: "firerang",
  metadata: {
    aspect: SavedSpellAspect.Fire,
    imports: ["fire","aim","self","wait","vector"],
    icon: {
      "backgroundColor": 4005920,
      "layers": [
        {
          "iconKey": "fireball",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -10,
          "color": 16750181
        },
        {
          "iconKey": "aim",
          "position": {
            "x": 15,
            "y": 0
          },
          "scale": 0.59,
          "rotation": 5,
          "color": 16056063
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -16,
            "y": 1
          },
          "scale": 0.63,
          "rotation": 8,
          "color": 15859711
        }
      ]
    },
  },
};

export default metadata;
